import React, {useContext} from "react"
import {Panel, DataRow} from "../../PDFPrimitives"
import {PDFContext} from "../../BasePDF"

// Buy Rate + Rate Markup = Sell Rate (the customer's APR), as in the lease RateInformationPDF.
export const FinanceDealerRateInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Rate Information">
            <DataRow label="Buy Rate"       value={pdfData.buy_rate}/>
            <DataRow label="Rate Markup"    value={pdfData.rate_markup} variant="muted"/>
            <DataRow label="Reserve Profit" value={pdfData.reserve_profit.toDollarFormat()} variant="muted"/>
            <DataRow
                label="Sell Rate"
                value={pdfData.disclosed_rate}
                isTotal
                variant="bold"
                isLast
            />
        </Panel>
    )
}
